(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scntd-bottle-spotlight"] && !Shopify.designMode) return;
  try {
    
  function initScntdBottleSpotlights(root) {
    root.querySelectorAll('[data-bottle-spotlight]').forEach((section) => {
      if (section.dataset.bottleReady === 'true') return;
      section.dataset.bottleReady = 'true';
      const image = section.querySelector('.scntd-bottle-spotlight__custom-image');
      const placeholder = section.querySelector('[data-custom-placeholder]');
      const selectedName = section.querySelector('[data-selected-color]');
      const colorProperty = section.querySelector('[data-bottle-color-property]');
      const choices = section.querySelectorAll('[data-color-choice]');
      let imageRequest = 0;
      choices.forEach((choice) => {
        choice.addEventListener('click', () => {
          const request = ++imageRequest;
          choices.forEach((other) => {
            const active = other === choice;
            other.classList.toggle('is-selected', active);
            other.setAttribute('aria-pressed', String(active));
          });
          if (selectedName) selectedName.textContent = choice.dataset.colorName || '';
          if (colorProperty) colorProperty.value = choice.dataset.colorName || '';
          if (image) {
            const source = window.matchMedia('(max-width: 749px)').matches
              ? choice.dataset.colorImageMobile
              : choice.dataset.colorImage;
            if (source) {
              const nextImage = new Image();
              nextImage.onload = () => {
                if (request !== imageRequest) return;
                image.removeAttribute('srcset');
                image.removeAttribute('sizes');
                image.src = source;
                image.alt = choice.dataset.colorName || '';
                image.hidden = false;
                if (placeholder) placeholder.hidden = true;
              };
              nextImage.src = source;
            } else {
              image.hidden = true;
              if (placeholder) placeholder.hidden = false;
            }
          }
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initScntdBottleSpotlights(document), { once: true });
  } else {
    initScntdBottleSpotlights(document);
  }
  document.addEventListener('shopify:section:load', (event) => initScntdBottleSpotlights(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scntd-card-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  function initScntdCardBundles(root) {
    root.querySelectorAll('[data-scntd-card-bundle]').forEach((builder) => {
      if (builder.dataset.bundleReady === 'true') return;
      builder.dataset.bundleReady = 'true';

      const packInputs = Array.from(builder.querySelectorAll('[data-pack-option]'));
      const cards = Array.from(builder.querySelectorAll('[data-bundle-card]'));
      const addButton = builder.querySelector('[data-bundle-add]');
      const buttonLabel = builder.querySelector('[data-bundle-button-label]');
      const spinner = builder.querySelector('[data-bundle-spinner]');
      const status = builder.querySelector('[data-bundle-selection-status]');
      const message = builder.querySelector('[data-bundle-message]');
      const originalTotal = builder.querySelector('[data-bundle-original-total]');
      const bundleTotal = builder.querySelector('[data-bundle-total]');
      const saving = builder.querySelector('[data-bundle-saving]');
      const discountCents = Number(builder.dataset.discountCents || 0);
      const locale = builder.dataset.locale || 'en';
      const currency = builder.dataset.currency || 'PKR';

      const formatMoney = (cents) => new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'code',
        maximumFractionDigits: 0,
      }).format(cents / 100);

      const getPackInput = () => packInputs.find((input) => input.checked) || packInputs[0];
      const getSelectedCards = () => cards.filter((card) => card.querySelector('[data-bundle-toggle]').checked);

      const update = () => {
        const packInput = getPackInput();
        const packSize = Number(packInput.value);
        let selectedCards = getSelectedCards();

        if (selectedCards.length > packSize) {
          selectedCards.slice(packSize).forEach((card) => {
            card.querySelector('[data-bundle-toggle]').checked = false;
          });
          selectedCards = getSelectedCards();
        }

        cards.forEach((card) => {
          const toggle = card.querySelector('[data-bundle-toggle]');
          const variant = card.querySelector('[data-bundle-variant]');
          const selected = toggle.checked;
          const atLimit = selectedCards.length >= packSize;
          card.classList.toggle('is-selected', selected);
          card.classList.toggle('is-disabled', !selected && atLimit);
          if (!card.classList.contains('is-unavailable')) toggle.disabled = !selected && atLimit;
          variant.disabled = !selected;
        });

        const selectionComplete = selectedCards.length === packSize;
        let calculatedOriginal = Number(packInput.dataset.originalTotal || 0);

        if (selectionComplete) {
          calculatedOriginal = selectedCards.reduce((sum, card) => {
            const variant = card.querySelector('[data-bundle-variant]');
            return sum + Number(variant.selectedOptions[0].dataset.price || 0);
          }, 0);
        }

        const calculatedSaving = discountCents * packSize;
        const calculatedBundle = Math.max(0, calculatedOriginal - calculatedSaving);
        originalTotal.textContent = formatMoney(calculatedOriginal);
        bundleTotal.textContent = formatMoney(calculatedBundle);
        saving.textContent = formatMoney(calculatedSaving);
        status.textContent = `${selectedCards.length} ${builder.dataset.selectedLabel} ${packSize}`;
        addButton.disabled = !selectionComplete;
        buttonLabel.textContent = selectionComplete
          ? `${builder.dataset.addLabel} · ${formatMoney(calculatedBundle)}`
          : `${builder.dataset.chooseLabel} ${packSize - selectedCards.length} ${builder.dataset.cardsLabel}`;
      };

      packInputs.forEach((input) => input.addEventListener('change', update));
      cards.forEach((card) => {
        card.querySelector('[data-bundle-toggle]').addEventListener('change', update);
        card.querySelector('[data-bundle-variant]').addEventListener('change', update);
      });

      addButton.addEventListener('click', async () => {
        const packInput = getPackInput();
        const selectedCards = getSelectedCards();
        const packSize = Number(packInput.value);
        if (selectedCards.length !== packSize) return;

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        buttonLabel.textContent = builder.dataset.loadingLabel;
        spinner.classList.remove('hidden');
        message.hidden = true;

        const items = selectedCards.map((card) => ({
          id: card.querySelector('[data-bundle-variant]').value,
          quantity: 1,
          properties: {
            '_SCNTD card bundle': `Pack of ${packSize}`,
          },
        }));

        try {
          const response = await fetch(`${builder.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(builder.dataset.cartUrl);
        } catch (error) {
          message.textContent = builder.dataset.errorLabel;
          message.hidden = false;
          addButton.removeAttribute('aria-busy');
          spinner.classList.add('hidden');
          update();
        }
      });

      update();
    });
  }

  initScntdCardBundles(document);
  document.addEventListener('shopify:section:load', (event) => initScntdCardBundles(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scntd-shoppable-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scntd-shoppable-reels')) {
    customElements.define(
      'scntd-shoppable-reels',
      class ScntdShoppableReels extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.track = this.querySelector('[data-reels-track]');
          this.cards = Array.from(this.querySelectorAll('[data-reel-card]'));
          this.activeCards = new Set();
          this.pendingPlays = new WeakMap();
          this.autoRetries = new WeakMap();
          this.sectionVisible = false;
          this.frame = null;
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.addedLabel = this.dataset.addedLabel || '';
          this.onClickBound = this.onClick.bind(this);
          this.onSubmitBound = this.onSubmit.bind(this);
          this.onVisibilityBound = this.onVisibilityChange.bind(this);
          this.onMotionBound = this.onMotionChange.bind(this);
          this.onScrollBound = this.scheduleEvaluation.bind(this);
          this.onResizeBound = this.scheduleEvaluation.bind(this);
          this.onBlockSelectBound = this.onBlockSelect.bind(this);
          this.addEventListener('click', this.onClickBound);
          this.addEventListener('submit', this.onSubmitBound);
          this.addEventListener('shopify:block:select', this.onBlockSelectBound);
          document.addEventListener('visibilitychange', this.onVisibilityBound);
          window.addEventListener('resize', this.onResizeBound, { passive: true });
          window.addEventListener('scroll', this.onScrollBound, { passive: true });
          this.track?.addEventListener('scroll', this.onScrollBound, { passive: true });
          this.motionQuery.addEventListener('change', this.onMotionBound);
          if ('IntersectionObserver' in window) {
            this.sectionObserver = new IntersectionObserver((entries) => {
              this.sectionVisible = entries[0].isIntersecting;
              this.scheduleEvaluation();
            });
            this.sectionObserver.observe(this);
          }
          this.scheduleEvaluation();
        }

        disconnectedCallback() {
          this.sectionObserver?.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          this.removeEventListener('click', this.onClickBound);
          this.removeEventListener('submit', this.onSubmitBound);
          this.removeEventListener('shopify:block:select', this.onBlockSelectBound);
          document.removeEventListener('visibilitychange', this.onVisibilityBound);
          window.removeEventListener('resize', this.onResizeBound);
          window.removeEventListener('scroll', this.onScrollBound);
          this.track?.removeEventListener('scroll', this.onScrollBound);
          this.motionQuery?.removeEventListener('change', this.onMotionBound);
          this.pauseAll();
        }

        scheduleEvaluation() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.evaluateVisibleCards();
          });
        }

        evaluateVisibleCards() {
          const sectionBox = this.getBoundingClientRect();
          const isOnScreen = sectionBox.bottom > 0 && sectionBox.top < window.innerHeight;
          if (document.hidden || this.motionQuery.matches || !this.track || !isOnScreen || (this.sectionObserver && !this.sectionVisible)) {
            this.pauseAll();
            return;
          }

          const trackBox = this.track.getBoundingClientRect();
          const viewportWidth = document.documentElement.clientWidth;
          const candidates = this.cards.map((card) => {
            const box = card.getBoundingClientRect();
            const visibleWidth = Math.max(0, Math.min(box.right, trackBox.right, viewportWidth) - Math.max(box.left, trackBox.left, 0));
            const visibleHeight = Math.max(0, Math.min(box.bottom, window.innerHeight) - Math.max(box.top, 0));
            const horizontal = visibleWidth / Math.max(box.width, 1);
            const vertical = visibleHeight / Math.max(box.height, 1);
            return { card, horizontal, vertical };
          }).filter(({ card, horizontal, vertical }) => card.querySelector('template[data-video-template], video') && horizontal >= 0.4 && vertical >= 0.2);

          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const chosen = isMobile
            ? candidates.sort((a, b) => b.horizontal * b.vertical - a.horizontal * a.vertical).slice(0, 1)
            : candidates;
          const nextCards = new Set(chosen.map(({ card }) => card));

          this.activeCards.forEach((card) => {
            if (!nextCards.has(card)) this.deactivateCard(card);
          });
          this.activeCards = nextCards;
          this.activeCards.forEach((card) => {
            card.classList.add('is-active');
            this.playCard(card);
          });
        }

        ensureVideo(card) {
          let video = card.querySelector('video');
          if (video) return video;
          const template = card.querySelector('template[data-video-template]');
          const host = card.querySelector('[data-video-host]');
          if (!template || !host || this.motionQuery.matches) return null;
          const fragment = template.content.cloneNode(true);
          video = fragment.querySelector('video');
          if (!video) return null;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.controls = false;
          video.preload = 'metadata';
          const retry = () => {
            if (this.activeCards.has(card) && video.paused && !document.hidden && !this.motionQuery.matches) this.playCard(card);
          };
          video.addEventListener('loadeddata', retry);
          video.addEventListener('canplay', retry);
          video.addEventListener('playing', () => {
            this.autoRetries.delete(video);
            if (this.activeCards.has(card) && !document.hidden && !this.motionQuery.matches) {
              card.classList.add('is-playing');
            } else {
              video.pause();
            }
          });
          video.addEventListener('pause', () => card.classList.remove('is-playing'));
          video.addEventListener('error', () => card.classList.remove('is-playing'));
          video.addEventListener('volumechange', () => {
            if (!video.muted) video.muted = true;
          });
          host.appendChild(fragment);
          return card.querySelector('video');
        }

        playCard(card) {
          const video = this.ensureVideo(card);
          if (!video) return;
          video.muted = true;
          if (!video.paused || this.pendingPlays.has(video)) return;
          const playAttempt = video.play();
          if (playAttempt && typeof playAttempt.then === 'function') {
            this.pendingPlays.set(video, playAttempt);
            playAttempt.then(
              () => {
                this.pendingPlays.delete(video);
                if (!this.isConnected || !this.activeCards.has(card) || document.hidden || this.motionQuery.matches) {
                  video.pause();
                  card.classList.remove('is-playing');
                }
              },
              () => {
                this.pendingPlays.delete(video);
                card.classList.remove('is-playing');
                const retries = this.autoRetries.get(video) || 0;
                if (retries < 1 && video.readyState >= 2 && this.activeCards.has(card)) {
                  this.autoRetries.set(video, retries + 1);
                  window.setTimeout(() => {
                    if (this.isConnected && this.activeCards.has(card) && video.paused && !document.hidden && !this.motionQuery.matches) this.playCard(card);
                  }, 300);
                }
              }
            );
          }
        }

        deactivateCard(card) {
          const video = card.querySelector('video');
          card.classList.remove('is-active', 'is-playing');
          if (!video) return;
          video.pause();
          video.muted = true;
        }

        pauseAll() {
          this.cards?.forEach((card) => this.deactivateCard(card));
          this.activeCards.clear();
        }

        onClick(event) {
          const previous = event.target.closest('[data-reels-previous]');
          const next = event.target.closest('[data-reels-next]');
          if (previous || next) {
            const firstCard = this.cards[0];
            if (!firstCard || !this.track) return;
            const styles = getComputedStyle(this.track);
            const gap = parseFloat(styles.columnGap || styles.gap) || 0;
            const direction = document.documentElement.dir === 'rtl' ? -1 : 1;
            const step = (firstCard.getBoundingClientRect().width + gap) * direction;
            this.track.scrollBy({
              left: previous ? -step : step,
              behavior: this.motionQuery.matches ? 'auto' : 'smooth',
            });
            return;
          }

          const card = event.target.closest('[data-reel-card]');
          if (!card || event.target.closest('a, button, form') || this.motionQuery.matches || document.hidden) return;
          if (window.matchMedia('(max-width: 749px)').matches) {
            this.activeCards.forEach((activeCard) => {
              if (activeCard !== card) this.deactivateCard(activeCard);
            });
            this.activeCards.clear();
          }
          this.activeCards.add(card);
          card.classList.add('is-active');
          this.playCard(card);
          this.scheduleEvaluation();
        }

        async onSubmit(event) {
          const form = event.target;
          if (!(form instanceof HTMLFormElement) || !form.matches('.scntd-reels__form')) return;
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          const spinner = form.querySelector('[data-cta-spinner]');
          const status = form.closest('.scntd-reels__product')?.querySelector('.scntd-reels__status');
          if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
          if (spinner) spinner.hidden = false;
          if (status) status.hidden = true;

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const formData = new FormData(form);
          let sectionIds = ['cart-icon-bubble'];
          if (cart && typeof cart.getSectionsToRender === 'function') {
            sectionIds = cart.getSectionsToRender().map((entry) => entry.id).filter(Boolean);
          }
          formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
          if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button);

          const config = typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          try {
            const addUrl = window.routes?.cart_add_url || form.action;
            const response = await fetch(addUrl, config);
            const data = await response.json();
            if (!response.ok || data.status) throw new Error(data.description || data.message || window.cartStrings?.error);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              try {
                await publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'scntd-shoppable-reels',
                  productVariantId: formData.get('id'),
                  cartData: data,
                });
              } catch {}
            }
            if (cart && typeof cart.renderContents === 'function') {
              try {
                cart.renderContents(data);
              } catch {
                this.refreshCartIcon(data);
              }
            } else {
              this.refreshCartIcon(data);
            }
            if (status) {
              status.setAttribute('role', 'status');
              status.textContent = this.addedLabel;
              status.hidden = false;
            }
          } catch (error) {
            if (status) {
              status.setAttribute('role', 'alert');
              status.textContent = error.message || window.cartStrings?.error || '';
              status.hidden = false;
            }
          } finally {
            button.removeAttribute('aria-busy');
            button.disabled = false;
            if (spinner) spinner.hidden = true;
          }
        }

        refreshCartIcon(data) {
          const html = data.sections?.['cart-icon-bubble'];
          const target = document.getElementById('cart-icon-bubble');
          if (!html || !target) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const source = parsed.querySelector('.shopify-section') || parsed.body;
          target.innerHTML = source.innerHTML;
        }

        onVisibilityChange() {
          if (document.hidden) {
            this.pauseAll();
          } else {
            this.scheduleEvaluation();
          }
        }

        onMotionChange(event) {
          if (event.matches) {
            this.pauseAll();
          } else {
            this.scheduleEvaluation();
          }
        }

        onBlockSelect(event) {
          const card = event.target.closest?.('[data-reel-card]');
          if (!card || !this.contains(card)) return;
          card.scrollIntoView({
            behavior: this.motionQuery.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center',
          });
          window.setTimeout(() => this.scheduleEvaluation(), this.motionQuery.matches ? 0 : 350);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scntd-trustoo-reviews"] && !Shopify.designMode) return;
  try {
    
  const mountTrustooReviews = () => {
    const mount = document.getElementById('trustoo-text-carousel');
    const widget = document.getElementById('trustoo-widget-wrapper');

    if (!mount || !widget || mount.contains(widget)) return false;

    mount.appendChild(widget);
    return true;
  };

  if (!mountTrustooReviews()) {
    const observer = new MutationObserver(() => {
      if (mountTrustooReviews()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scntd-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scntd-video-hero')) {
    customElements.define(
      'scntd-video-hero',
      class ScntdVideoHero extends HTMLElement {
        connectedCallback() {
          this.videos = Array.from(this.querySelectorAll('.scntd-video-hero__video'));
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');
          this.isVisible = this.visibleEnough();
          this.isPageReady = document.readyState === 'complete';
          this.handleVisibility = this.syncPlayback.bind(this);
          this.handleViewportChange = this.syncPlayback.bind(this);
          this.handleMotionChange = this.syncPlayback.bind(this);
          this.handlePageReady = () => {
            this.isPageReady = true;
            this.syncPlayback();
          };
          this.handleTap = this.retryPlayback.bind(this);
          this.handleMediaState = this.updatePoster.bind(this);

          this.addEventListener('click', this.handleTap);
          this.videos.forEach((video) => {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.addEventListener('playing', this.handleMediaState);
            video.addEventListener('pause', this.handleMediaState);
            video.addEventListener('canplay', this.handleVisibility);
          });
          document.addEventListener('visibilitychange', this.handleVisibility);
          this.mobileQuery.addEventListener('change', this.handleViewportChange);
          this.motionQuery.addEventListener('change', this.handleMotionChange);
          if (!this.isPageReady) window.addEventListener('load', this.handlePageReady, { once: true });

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                this.isVisible = entries[0].intersectionRatio >= 0.15;
                this.syncPlayback();
              },
              { threshold: 0.15 }
            );
            this.observer.observe(this);
          } else {
            this.isVisible = true;
          }

          this.syncPlayback();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleTap);
          this.videos.forEach((video) => {
            video.removeEventListener('playing', this.handleMediaState);
            video.removeEventListener('pause', this.handleMediaState);
            video.removeEventListener('canplay', this.handleVisibility);
          });
          document.removeEventListener('visibilitychange', this.handleVisibility);
          window.removeEventListener('load', this.handlePageReady);
          this.mobileQuery.removeEventListener('change', this.handleViewportChange);
          this.motionQuery.removeEventListener('change', this.handleMotionChange);
          if (this.observer) this.observer.disconnect();
        }

        activeVideos() {
          return this.videos.filter((video) => window.getComputedStyle(video).display !== 'none');
        }

        visibleEnough() {
          const bounds = this.getBoundingClientRect();
          const visibleHeight = Math.min(bounds.bottom, window.innerHeight) - Math.max(bounds.top, 0);
          return bounds.height > 0 && visibleHeight / bounds.height >= 0.15;
        }

        prepareVideo(video) {
          if (video.dataset.sourceReady === 'true') return;

          let hasSource = false;
          video.querySelectorAll('source[data-src]').forEach((source) => {
            if (!source.dataset.src) return;
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
            hasSource = true;
          });

          if (!hasSource) return;
          video.dataset.sourceReady = 'true';
          video.load();
        }

        syncPlayback() {
          const shouldPlay = this.isPageReady && this.isVisible && !document.hidden && !this.motionQuery.matches;
          const activeVideos = this.activeVideos();

          this.videos.forEach((video) => {
            if (!shouldPlay || !activeVideos.includes(video)) video.pause();
          });

          if (shouldPlay) {
            activeVideos.forEach((video) => {
              this.prepareVideo(video);
              if (!video.paused) return;
              video.muted = true;
              const request = video.play();
              if (request) request.catch(() => this.updatePoster());
            });
          }
          this.updatePoster();
        }

        retryPlayback(event) {
          if (event.target.closest('a, button, input, select, textarea')) return;
          if (this.activeVideos().some((video) => video.paused)) this.syncPlayback();
        }

        updatePoster() {
          this.classList.toggle('is-playing', this.activeVideos().some((video) => !video.paused && video.readyState >= 2));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
